import type { Schemas } from "../api/client";

export type Fulfilment = Schemas["Order"]["fulfilment"];

/** How an order reaches the customer, in a list or a header (PRD 5.8). */
export const FULFILMENT_LABEL: Record<Fulfilment, string> = {
  delivery: "Delivery",
  urgent_delivery: "Urgent delivery",
  terminal_pickup: "Bus terminal pickup",
  pickup: "Pickup",
};
